var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25593 7.12713C5.85716 7.58759 5.14284 7.58759 4.74407 7.12713L0.43778 2.15465C-0.123096 1.50701 0.336957 0.499999 1.19371 0.499999L9.80629 0.5C10.663 0.5 11.1231 1.50701 10.5622 2.15465L6.25593 7.12713Z",
    fill: "#008FF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonDown);
export default __webpack_public_path__ + "static/media/polygon-down.d59fe88851b5dc20bc12daead2a85973.svg";
export { ForwardRef as ReactComponent };